/* fw-ipad-submenu-fix-v2 */
(function() {
  // Wait for custom elements to be defined
  function applyFix() {
    // Patch DetailsDisclosure.prototype.onFocusOut
    var proto = window.DetailsDisclosure ? window.DetailsDisclosure.prototype : null;
    if (!proto) {
      // Custom element not yet defined — retry shortly
      setTimeout(applyFix, 50);
      return;
    }

    // Track touch-initiated opens per instance
    if (proto._fwTouchPatched) return; // idempotent
    proto._fwTouchPatched = true;

    // Wrap onSummaryClick / touchend to set _fwTouchOpened flag
    document.addEventListener('touchend', function(e) {
      var summary = e.target && e.target.closest ? e.target.closest('header-menu > details > summary, .header__inline-menu summary') : null;
      if (summary) {
        var instance = summary.closest('header-menu, details-disclosure');
        if (instance) instance._fwTouchOpened = true;
      }
    }, { passive: true, capture: true });

    // Override onFocusOut to skip when touch-opened
    proto.onFocusOut = function() {
      if (this._fwTouchOpened) return;
      var self = this;
      setTimeout(function() {
        if (!self.contains(document.activeElement)) self.close();
      });
    };

    // Override close to reset flag
    var origClose = proto.close;
    proto.close = function() {
      this._fwTouchOpened = false;
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    };

    // Outside-tap closes touch-opened menus
    document.addEventListener('touchend', function(e) {
      document.querySelectorAll('header-menu > details[open]').forEach(function(details) {
        var instance = details.closest('header-menu, details-disclosure');
        if (instance && instance._fwTouchOpened && !details.contains(e.target)) {
          instance._fwTouchOpened = false;
          instance.close();
        }
      });
    }, { passive: true, capture: true });
  }
  applyFix();
})();
